import { render, staticRenderFns } from "./ViewDetailsMain.view.vue?vue&type=template&id=0b85fa8f&"
import script from "./ViewDetailsMain.view.vue?vue&type=script&lang=js&"
export * from "./ViewDetailsMain.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports